import { CSSProperties, useEffect, useState } from "react";
import { DataColumn } from "../../types";
import { createUUID, formatDate, translate } from "../../common";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import useResize from "../../hooks/use-resizer";



export interface ObjectGridProps {
  value: any;
  style?: CSSProperties;
  className?: string;
  id?: string;
}

interface ObjectGridItem {
    label: string;
    value: any;
    type: string;

}


export function ObjectGrid(props: ObjectGridProps) {
  
    const [_items, setItems] = useState<ObjectGridItem[]>([]);
    const [_columns, setColumns] = useState<DataColumn[]>([]);
    const _size = useResize(props.id ?? "object-grid");

    const buildItems = (obj: any) => {
        const items: ObjectGridItem[] = [];
        for (const [key, value] of Object.entries(obj)) {
            let type: string = typeof value;
            if (value instanceof Date) {
                type = "date";
            }
           
           
           
            items.push({ label: key, value: value, type: type });
        }
        return items.sort((a, b) => a.label.localeCompare(b.label));

    }

    useEffect(() => {
        let value = props.value || {};
        let items = buildItems(value);
        setItems(items);
    }, [props.value]);

    const itemBody = (rowData: ObjectGridItem) => {
        let type = rowData.type;
        let value: any = rowData.value;
        let style: CSSProperties = { margin: "4px" };
        if (type === "boolean") {
            value =  value ? translate("YES") : translate("NO");
        } else if (type === "date") {
            value = formatDate(rowData.value);
        } 
        // else if (type ==="number")
        //     style.textAlign = "right";

        return <div style={style}>{value}</div>;

      


    }

    return (
        <div id={props.id ?? "object-grid"} className={`${props.className ?? ""} fbx-full-height`} style={props.style} >
            <DataTable value={_items} size="small" scrollable scrollHeight={_size ? `${_size.height - 10}px` : "400px"} >
                <Column field="label" header={translate("PROPERTY")} headerStyle={{paddingLeft: 10}} bodyStyle={{paddingLeft: 10}}></Column>
                <Column field="value" header={translate("VALUE")} body={itemBody}></Column>
                <Column headerStyle={{width: 100}}/>
            </DataTable>
        </div>
    )

}